<template>
	<div>
		<div class="wrapper">
			<div class="use" v-if="status===0 || status===2">
				<div class="head_tip">客服热线 0571-85199986(服务时间8:30-20:00)</div>
				<div class="block">
					<header>请点击选择需要充值的产品<span style="color: red;">(多选一)</span></header>
					<div class="gz" @click="onChecked">
						<div class="tip">
							<label>
								本电子券仅支持以下商品中<span style="color: red;">任选一种</span>充值，<span style="color: red;">不支持多个</span>充值，一旦选择产品并绑定手机号充值表示您接受本条款，充值操作不可撤销。
								<br />
								<br />
								<label>
									<span>我已阅读并同意以上条款。</span>
									<img v-if="mflag == 0" src="../assets/quan.png" />
									<img v-if="mflag == 1" src="../assets/quan2.png" />
								</label>
							</label>
						</div>
					</div>
					<div class="content">
						<div class="list" v-for="item in productCategoryList" :key='item.productCategoryId'>
							<div class="box">
								<img :src="item.logoPath" :alt="item.name">
								<span>{{item.name}}</span>
								<label @click="toPage(item)" name="ea" class="select">选择</label>
							</div>
						</div>
					</div>
					<!-- <div class="gz">
						<h1>券码规则</h1>
						<div class="tip">
							此电子券只能从中<span style="color: red;">选择一种产品</span>充值，<span style="color: red;">不能多个</span>充值<br />
							请注意一旦选择产品并绑定手机号码后将<span style="color: red;">无法更改</span>。
						</div>
					</div> -->
				</div>
			</div>
			<div class="use" v-if="status===1 || status===3">
				<div class="head">
					<header class="used">
						<div class="lt">
							<p>{{typeName}}</p>
							<span>链接有效期至:{{expiredDate}}</span>
						</div>
					</header>
				</div>
				<div class="bd">
					<div class="nodata">
						<img src="../assets/used.png" alt="电子券已使用">
						<p>电子券已使用</p>
					</div>
				</div>
			</div>
			<div class="use" v-if="status===4">
				<div class="head">
					<header class="used">
						<div class="lt">
							<p>{{typeName}}</p>
							<span>有效期至:{{expiredDate}}</span>
						</div>
					</header>
				</div>
				<div class="bd">
					<div class="nodata">
						<img src="../assets/outDate.png" alt="电子券已失效">
						<p>电子券已失效</p>
					</div>
				</div>
			</div>
			<div class="result" v-if="flag">
				<div class="dec">
					<img :src="srcDec" alt="成功">
					<p>{{dec}}</p>
				</div>
			</div>
			<div class="use_loading" v-if="loading">
				<div class="loading">
					<img src="../assets/loading.png" alt="加载中">
				</div>
			</div>
			<div class="pop" v-if="takeVisible">
				<div class="win">
					<div class="box">
						<h4>电子券有效日期为：</h4>
						<label>生效时间：{{this.effectiveDate}} 00:00:00</label><br />
						<label>失效时间：{{this.expiredDate}} 23:59:59</label><br />
						<br />
						<label>温馨提示：本券码为特殊活动券，超过有效期券码会失效，失效券码请联系原购买渠道，若在有效期内无法使用请联系客服电话:0571-85199986</label>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				key: this.$route.query.key,
				// key:'gOTgQvv6AOgjHkZ98W',
				status: 0,
				loading: true,
				typeName: '',
				expiredDate: '',
				mobile: '',
				productCategoryList: [],
				// 是否生效，未生效弹出层挡住
				takeVisible: false,
				effectiveDate: '',
				productId: '',
				qqInfo: 0,
				mflag: 0,
				// 提示框内容
				flag: false,
				dec: '',
				srcDec: require('../assets/success.png'),
			}
		},
		created() {
			document.title = '云之谷多类型充值'
		},
		mounted() {
			this.getTicketStatus(this.key);
		},
		methods: {
			/** 跳转页面
			 * @param {Object} item 电子券信息
			 */
			toPage(item) {
				if (this.mflag != 1) {
					this.flag = true;
					this.srcDec = require('../assets/fail.png');
					this.dec = '请同意条款内容！';
					setTimeout((() => {
						this.flag = false;
					}), 1000);
					return
				}
				this.$router.push({
					path: '/manyTypeCode',
					query: {
						txt: item.name,
						logo: item.logoPath,
						key: this.key,
						typeName: this.typeName,
						expiredDate: this.expiredDate,
						productCategoryId: item.productCategoryId,
						productId: this.productId
					}
				})
			},
			/**
			 * 我已同意复选框点击事件
			 */
			onChecked() {
				if (this.mflag == 1) {
					this.mflag = 0
				} else {
					this.mflag = 1
				}
			},
			toQQInfo(qqInfo) {
				this.qqInfo = qqInfo;
			},
			getTicketStatus(key) {
				const obj = {
					ticketNo: key
				}
				this.$http.POST('productTicket/selectProductTicket', obj).then(res => {
					// console.log(res);
					this.loading = false;
					if (res.code === 0) {
						this.status = res.data.useStatus;
						this.typeName = res.data.ticketName;
						this.expiredDate = res.data.expiredDate;
						this.mobile = res.data.mobile;
						this.productCategoryList = res.data.productCategoryList;
						this.productId = res.data.productId;
						document.title = this.typeName;
						// 获取生效日期
						this.effectiveDate = res.data.effectiveDate;
						let d = res.data.effectiveDate
						if (d.length === 10) { // 加上时分秒
							d = d + " 00:00:00";
						}
						// 如果未生效，弹出提示
						if (new Date().getTime() < new Date(d).getTime()) {
							this.takeVisible = true
						}
					} else {
						if (res.code === 2000) {
							this.$router.push({
								path: '/404'
							})
						} else {
							alert(res.msg);
						}
					}
				});
			}
		}
	}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
	.qqInfo {
		img {
			max-width: 100%;
			padding: 5px 0;
		}
	}

	.wrapper {
		height: 100%;
		width: 100%;
		position: relative;
		font-size: 12px;

		.use {
			height: 100%;
			background: #F3F3F3;
			.head_tip {
				background: #FEFCEC;
				padding: 10px;
				// line-height: 36px;
				font-size: 14px;
				color: #F76A24;
			}

			.block {
				padding: 16px;

				header {
					font-size: 18px;
					color: #333333;
				}

				.gz {
					display: flex;
					width: 100%;
					margin: 20px auto;


					.tip {
						width: 100%;
						border: #FFFFFF solid 4px;
						// margin: 20px 0px;
						padding: 10px;
						font-size: 18px;

						label {
							label {
								height: 32px;
								line-height: 32px;

								span {
									float: left;
								}

								input {
									float: right;
									width: 24px;
									height: 24px;
									border-radius: 12px;
									background-color: #FFFFFF;
									border: 1px #1C4F7E solid;
								}

								img {
									float: right;
									width: 26px;
									height: 26px;
									border-radius: 12px;
								}
							}
						}
					}
				}

				.content {
					display: flex;
					flex-direction: column;

					.list {
						background: #fff;
						height: 90px;
						width: 343px;
						border-radius: 4px;
						padding: 5px;
						box-sizing: border-box;
						margin-top: 16px;
						display: flex;

						.box {
							flex: 1;
							border: 1px solid #FFE4B9;
							border-radius: 2px;
							display: flex;
							align-items: center;

							img {
								width: 68px;
								height: 68px;
							}

							span {
								font-size: 16px;
								color: #333333;
								font-weight: bold;
								padding-left: 6.5px;
								flex: 1;
							}

							.select {
								border-radius: 14.25px;
								margin-right: 10px;
								font-size: 15px;
								color: #fff;
								background: linear-gradient(to right, #F9AF2F, #F5881A);
								width: 85px;
								height: 30px;
								line-height: 30px;
								text-align: center;
								font-weight: bold;
							}
						}
					}
				}
			}

			.head {
				background: #fff;
				height: 110px;
				padding: 10px 15px 15px 15px;
				box-sizing: border-box;

				header.used {
					height: 85px;
					background: url('../assets/used_bg.png') no-repeat;
					background-size: 342px 85px;
					padding: 10px 15px 15px 15px;
					box-sizing: border-box;

					.lt {
						// padding: 10px 0 0 15px;
						float: left;
						display: flex;
						flex-direction: column;

						p {
							font-size: 17px;
							color: #333333;
							font-weight: bold;
						}

						span {
							font-size: 14px;
							color: #333333;
							padding-top: 2px;
						}
					}
				}
			}

			.bd {
				display: flex;
				justify-content: center;
				align-items: center;

				.nodata {
					display: flex;
					flex-direction: column;
					justify-content: center;
					align-items: center;
					padding-top: 50px;

					img {
						width: 100px;
						height: 100px;
					}

					p {
						font-size: 17px;
						color: #555555;
						padding-top: 10px;
					}
				}

				.ft {
					padding: 4px 16px 0 16px;
					font-size: 16px;
					color: #888888;
				}
			}
		}

		.result {
			position: fixed;
			width: 100%;
			height: 100%;
			left: 0;
			top: 0px;
			display: flex;
			justify-content: center;
			align-items: center;
			z-index: 999;

			.dec {
				min-width: 120px;
				height: 120px;
				background: rgba(58, 58, 58, 0.9);
				display: flex;
				align-items: center;
				justify-content: center;
				flex-direction: column;
				border-radius: 2px;
				padding: 0 10px;

				img {
					width: 36px;
					height: 36px;
					font-size: 14px;
				}

				p {
					font-size: 14px;
					color: #fff;
					padding-top: 8px;
				}
			}
		}


		.use_loading {
			position: absolute;
			height: 100%;
			width: 100%;
			z-index: 11;
			left: 0;
			top: 0;

			.loading {
				width: 100%;
				height: 100%;
				background: rgba(0, 0, 0, 0.5);
				display: flex;
				justify-content: center;
				align-items: center;

				img {
					width: 50px;
					height: 50px;
					animation: turn 1s linear infinite;
					margin: 100px auto;
				}

				@keyframes turn {
					0% {
						-webkit-transform: rotate(0deg);
					}

					25% {
						-webkit-transform: rotate(90deg);
					}

					50% {
						-webkit-transform: rotate(180deg);
					}

					75% {
						-webkit-transform: rotate(270deg);
					}

					100% {
						-webkit-transform: rotate(360deg);
					}
				}
			}
		}

		.pop {
			position: fixed;
			width: 100%;
			height: 100%;
			top: 0;
			left: 0;
			background: rgba(0, 0, 0, 0.5);
			display: flex;
			justify-content: center;
			align-items: center;

			.win {
				width: 325px;
				height: 350px;

				p {
					text-align: right;
					padding-bottom: 10px;

					i {
						display: inline-block;
						width: 31px;
						height: 31px;
						background: url('../assets/close.png') no-repeat;
						background-size: 31px 31px;
					}
				}

				.box {
					width: 100%;
					height: 310px;
					background: #F3F3F3;
					border-radius: 7px;
					padding: 30px 15px;
					box-sizing: border-box;

					.submit {
						margin: 30px 25px 0 25px;
						width: 245px;
						height: 44px;
						border-radius: 22px;
						color: #fff;
						font-size: 18px;
						font-weight: bolder;
						background: linear-gradient(to right, #FF9A4F, #FF7509);
					}

					h1 {
						font-size: 18px;
						color: #333333;
						font-weight: bolder;
						padding-bottom: 16px;
					}

					.txt {
						margin-top: 16px;
						background: #fff;
						height: 50px;
						line-height: 50px;
						padding: 0 10px;
						display: flex;
						align-items: center;

						input {
							flex: 1;
							border: none;
							background: none;
							text-align: right;
							padding: 10px 0;
							font-size: 16px;
						}
					}

					.form {
						margin-top: 16px;
						display: flex;
						align-items: center;

						.code {
							display: flex;
							background: #fff;
							margin-right: 10px;
							height: 50px;
							align-items: center;
							padding: 0 10px;
							width: 200px;

							span {
								flex: 1;
							}

							input {
								width: 108px;
								border: none;
								background: none;
								text-align: right;
								padding: 10px 0;
								font-size: 16px;
							}
						}

						button,
						em {
							color: #fff;
							width: 120px;
							height: 30px;
							line-height: 30px;
							background: linear-gradient(to right, #FF8C37, #FF7201);
							font-size: 15px;
							border-radius: 15px;
							text-align: center;
							font-style: normal;
						}

						em {
							background: #555555;
						}
					}

					h4 {
						font-size: 18px;
						color: #FBB50B;
						font-weight: bolder;
						padding-bottom: 16px;
					}

					label {
						font-size: 16px;
						color: #FBB50B;
						font-weight: bolder;
						padding-bottom: 16px;
					}
				}
			}
		}
	}
</style>
